import React from 'react'
import 'stylesheets/EventsStyles/EventsStyles.css'
import { faLocationDot, faUserGroup } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useNavigate } from 'react-router-dom'
import { PROTECTED } from 'lib/routes'

const EventElement = ({ sponsored, event }) => {
    const navigate = useNavigate()
    const handleNoteClick = () => {
        navigate(`${PROTECTED}/eventsinfo/${event.id}`)
    }

    return (
        <div className="event-container" onClick={handleNoteClick}>
            <img className='banner' src={event.banner} alt="" />
            <div className='info-event'>
                <span className='date'>{event.date}</span>
                <span className={`advertised ${sponsored ? 'show' : 'hidden'}`}>{event.type === 'social' ? 'Social' : 'Sponsored'}</span>
                <div className='info-header'>
                    <div className='organizer-info'>
                        <img src={event.organizer[1]} alt="" />
                        <div className='text'>
                            <p className='organizer-name'>{event.organizer[0]}</p>
                            <p>Organizer</p>
                        </div>
                    </div>
                    <div className="attending-people">
                        <FontAwesomeIcon className='icon' icon={faUserGroup} />
                        <p>{event.people}</p>
                    </div>

                </div>
                <h3>{event.title}</h3>
                <div className='event-footer'>
                    <FontAwesomeIcon className='icon' icon={faLocationDot} />
                    <p>{event.location}</p>
                </div>
            </div>
        </div>
    )
}

export default EventElement